import angular, { IRequestShortcutConfig } from 'angular';

export function setAuthorizationHeader(
    token?: string,
    config: IRequestShortcutConfig = {}
): IRequestShortcutConfig {
    if (token) {
        // make config if it was null.
        const Authorization = token;
        const headers = { Authorization };
        // apply our AuthorizationHeader, let the provided config take precedence.
        config.headers = angular.extend(headers, config.headers);
    }
    return config;
}
